"use client";
import { Separator, Grid, GridItem, Stack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import GoogleMap from "./googleMap";
import { DATA_CENTER_LOCATION_LIST } from "./constants";

const DataCenterLocation = () => {
  return (
    <Stack gap={10}>
      {DATA_CENTER_LOCATION_LIST.map((location, index) => {
        const { address, name } = location;
        const isEven = index % 2 == 0;
        return (
          <Grid
            gap={8}
            key={index}
            templateColumns={{
              base: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            }}
          >
            <GridItem
              alignItems="center"
              borderBottomWidth={{ base: "0px", sm: "2px" }}
              borderBottomColor={"gray.300"}
              colSpan={{ base: 1, md: 2 }}
              display="flex"
              justifyContent={{ sm: isEven ? "flex-start" : "flex-end" }}
              order={{ sm: isEven ? 2 : 1 }}
            >
              <Stack>
                <Heading as="h3" variant={"headLine3"}>
                  {name}
                </Heading>
                <Separator
                  width={"50px"}
                  borderBottomWidth={"2px"}
                  borderBottomColor={"brand.100"}
                  opacity={1}
                />
              </Stack>
            </GridItem>
            <GridItem colSpan={1} order={{ sm: isEven ? 1 : 2 }}>
              <GoogleMap address={address} />
            </GridItem>
          </Grid>
        );
      })}
    </Stack>
  );
};

export default DataCenterLocation;
